var React = require('react');

function Waystopay (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#000","strokeLinejoin":"round","strokeWidth":"4"},[React.createElement("rect",{"height":"56","rx":"8","strokeLinecap":"round","width":"96","x":"22","y":"46","key":0}),React.createElement("path",{"d":"m34 72h24v18h-24z","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"m38 72v-6a8 8 0 0 1 16 0v6","key":2}),React.createElement("path",{"d":"m70 90h36","key":3}),React.createElement("path",{"d":"m70 58h36","key":4}),React.createElement("path",{"d":"m70 74h36","key":5}),React.createElement("path",{"d":"m22.22 95.87a8 8 0 0 1 -5.22-6.18l-6.9-39.41a8 8 0 0 1 6.51-9.28l78.82-13.68a8 8 0 0 1 9.25 6.51l2.12 12.17","strokeLinecap":"round","key":6}),React.createElement("path",{"d":"m58.07 46 35.47-6.17","key":7})]));
}

Waystopay.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = Waystopay;

Waystopay.default = Waystopay;
